(() => {
  'use strict';

  if (window.__moreheaFooterBackToTop) return;
  window.__moreheaFooterBackToTop = true;

  // Delegation continues to work when Shopify replaces a section in the editor.
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('.mh-footer [data-mh-footer-top]');
    if (!link || typeof window.scrollTo !== 'function') return;

    const reduceMotion = !window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });

    const mainContent = document.getElementById('MainContent');
    if (mainContent) mainContent.focus({ preventScroll: true });
  });
})();
